import Media from './media';

export default Media;
export { Media };